import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { BusinessInvoiceListPage } from '../business-invoice-list/business-invoice-list';
import { BusinessInvoiceSearchPage } from '../business-invoice-search/business-invoice-search';


@Component({
  selector: 'page-business-invoice-main',
  templateUrl: 'business-invoice-main.html',
})
export class BusinessInvoiceMainPage {

	invoices = BusinessInvoiceListPage;
	search = BusinessInvoiceSearchPage;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BusinessInvoiceMainPage');
  }

}


// WEBPACK FOOTER //
// ./src/pages/business-invoice-main/business-invoice-main.ts